<form [formGroup]="formAddressGroup">
    <expanded-card *ngIf="inCard" [cardExpanded]="true" [title]="cardTitle">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
    </expanded-card>
    <ng-container *ngIf="!inCard">
        <h3 *ngIf="title"> {{ title }}</h3>
        <ng-container  [ngTemplateOutlet]="content"></ng-container>
    </ng-container>
</form>


<ng-template #content>
        <div class="row m-l-4">
            <app-form-field label="Nom du destinataire" size="12" *ngIf="displayRecipientName">
                <app-input-text [parentFormGroup]="formAddressGroup"
                                parentFormControlName="recipientName"></app-input-text>
            </app-form-field>
            <ng-container *ngIf="accountCountryCode === 'BE' else notBeTmpl">
                <app-form-field label="Rue" size="12" sizeLg="6" sizeXl="8" *ngIf="displayStreet">
                    <app-input-text [parentFormGroup]="formAddressGroup"
                                    parentFormControlName="street"></app-input-text>
                </app-form-field>
                <app-form-field label="N°" size="12" sizeLg="6" sizeXl="4" *ngIf="displayNumber">
                    <app-input-text [parentFormGroup]="formAddressGroup"
                                    parentFormControlName="number"></app-input-text>
                </app-form-field>
            </ng-container>
            <ng-template #notBeTmpl>
                <app-form-field label="N°" size="12" sizeLg="6" sizeXl="4" *ngIf="displayNumber">
                    <app-input-text [parentFormGroup]="formAddressGroup"
                                    parentFormControlName="number"></app-input-text>
                </app-form-field>
                <app-form-field label="Rue" size="12" sizeLg="6" sizeXl="8" *ngIf="displayStreet">
                    <app-input-text [parentFormGroup]="formAddressGroup"
                                    parentFormControlName="street"></app-input-text>
                </app-form-field>
            </ng-template>

        </div>
        <div class="row m-l-4">
            <app-form-field label="Code postal" size="12" sizeLg="6" sizeXl="2">
                <app-autocomplete-input [parentFormGroup]="formAddressGroup" parentFormControlName="zipCode"
                                        (_onSearch)="searchLocalitiesByZipCode($event)"
                                        (_onSelection)="selectZipCode($event)"
                                        [optionList]="localitiesByZipCode"
                                        [valueElementProcessor]="valueZipCode"
                                        [displayElementProcessor]="displayZipCode"
                                        [displayOptionElementProcessor]="displayZipCodeOption"
                                        [autocompleteOff]="autocompleteZipCodeLocalityOff()"
                                        style="width: 100%;"
                ></app-autocomplete-input>
            </app-form-field>
            <app-form-field label="Localité" size="12" sizeLg="6" sizeXl="5">
                <app-autocomplete-input [parentFormGroup]="formAddressGroup" parentFormControlName="locality"
                                        (_onSearch)="searchLocalitiesByName($event)"
                                        (_onSelection)="selectLocality($event)"
                                        [optionList]="localitiesByName"
                                        [valueElementProcessor]="valueLocality"
                                        [displayElementProcessor]="displayLocality"
                                        [displayOptionElementProcessor]="displayLocalityOption"
                                        [autocompleteOff]="autocompleteZipCodeLocalityOff()"
                                        style="width: 100%;"
                ></app-autocomplete-input>
            </app-form-field>
            <app-form-field label="Pays" size="12" sizeLg="6" sizeXl="5">
                <app-select-filter [parentFormGroup]="formAddressGroup"
                                   noEntriesFoundLabel="Aucun pays trouvé"
                                   parentFormControlName="country"
                                   [elements]="countries"
                                   [filterElementProcessor]="filterCountry"
                                   style="width: 100%;">
                    <ng-template template-content let-element='element'>
                        {{element.label}}
                    </ng-template>
                </app-select-filter>
            </app-form-field>
            <app-form-field label="URL" size="12" *ngIf="displayUrl">
                <app-input-text [parentFormGroup]="formAddressGroup" parentFormControlName="url"></app-input-text>
            </app-form-field>
            <app-form-field label="Instructions pour l'itinéraire" size="12" *ngIf="displayNavigationInstructions">
                <app-input-text [parentFormGroup]="formAddressGroup" parentFormControlName="navigationInstructions"></app-input-text>
            </app-form-field>
        </div>
</ng-template>
